/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import type { JSX } from 'react';
import { MessageType } from '../../../interfaces/baseInterface';
import styles from './Notification.module.css';
import { useTranslation } from '../Translation/translationProvider';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';


interface NotificationProps{
  open: boolean
  handleClose: () => void
  type?: MessageType
  message?: string ,
  title?: string,
 
}


const Notification:React.FC<NotificationProps>= (props) =>{
    const { t } = useTranslation();
    const {open,handleClose,type,message, title}= props;

    const getModalBasedOnType = () => {
      if (!open) {
        return null;
      }

      let modal: JSX.Element = <> </>;
      if (message) {
        switch (type) {
          case MessageType.dialog:
            modal = (
              <Dialog open={open} onClose={handleClose}>
                <DialogTitle>
                  {title}{" "}
                  {handleClose ? (
                    <IconButton
                      aria-label="close"
                      onClick={handleClose}
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  ) : null}
                </DialogTitle>
                <DialogContent>
                  <div dangerouslySetInnerHTML={{ __html: t(message) }} />
                </DialogContent>
              </Dialog>
            );
            break;

          default:
            const notificationMainClass = MessageType.error === type ? styles.notificationError :  styles.notificationInfo
            modal = (
              <div className={notificationMainClass}>
                <span className={styles.notificationSign} />
                <span
                  className={styles.notificationText}
                  dangerouslySetInnerHTML={{ __html: t(message) }}
                />
                <span
                  onClick={handleClose}
                  className={styles.notifiactionClose}
                  role="button"tabIndex={0}
                >
                  ×
                </span>
              </div>
            );
        }
      }

      return modal;
    };

    return (
        <>
        {getModalBasedOnType()} 
        </>
    );
}

export default Notification;